export default __webpack_public_path__ + "locales/az/FormFillingTipsDialog.json?hash=25773186fdfccf654340ccb79915d983";